module.exports = __webpack_public_path__ + "img/reject-icon.9c580326.svg";